import { ActionMenuItemProp } from '../../molecules/ActionMenuItem/types';

export const addNewFlowItem: ActionMenuItemProp = {
  subTitle: 'Action',
  id: 'add-new-flow',
  icon: 'add-new-flow',
  title: 'Add a new flow',
  emoticonBg: 'transparent',
};
